import { render } from "./MapLegend.vue?vue&type=template&id=8c84b714&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"

import "./MapLegend.vue?vue&type=style&index=0&id=8c84b714&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c84b714"]])

export default __exports__